<template>
  <v-layout row justify-center align-baseline wrap class="mt-4 pt-2">
    <v-flex xs12 sm12 md5 lg6 xl6 class="mt-4 pt-4">
      <h2 class="mb-4 pl-4 pt-2">Education</h2>
      <v-card-text class="py-0">
        <v-timeline align-top dense>
          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">Jan 2008 -</div>
                <div class="caption font-weight-bold green--text">Dec 2010</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Sripatum University</strong>
                <div class="caption mb-2">Bachelor's degree, <br/> Information and Communication technology</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">Jan 2006 -</div>
                <div class="caption font-weight-bold green--text">Dec 2008</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Minburi Technical Collage</strong>
                <div class="caption mb-2">High Vocational Certificate, Major in Electronics, <br/> Computer Technique</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">Jan 2003 -</div>
                <div class="caption font-weight-bold green--text">Dec 2006</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Minburi Technical Collage</strong>
                <div class="caption mb-2">Vocational Certificate, <br/>Electrical and Electronics Engineering</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-flex>
    <v-flex xs12 sm12 md4 lg6 xl6 class="mt-4 pt-2">
      <h2 class="mb-4 pl-4">Experience</h2>
      <v-card-text class="py-0">
        <v-timeline align-top dense>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">Mar 2022 -</div>
                <div class="caption font-weight-bold green--text">PRESENT</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Manager, Internet & Mobile Solution</strong>
                <div class="caption mb-2">True Corporation Public Company Limited (true)</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">Dec 2022 -</div>
                <div class="caption font-weight-bold green--text">Mar 2023</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Manager, Internet & Mobile Solution</strong>
                <div class="caption mb-2">Total Access Communication<br/>Public Company Limited (dtac)</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>
          
          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">Dec 2021 -</div>
                <div class="caption font-weight-bold green--text">Dec 2022</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Senior Full Stack Developer</strong>
                <div class="caption mb-2">Central Siam Public (Thailand) Co.,Ltd. · Full-time</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">Mar 2016 -</div>
                <div class="caption font-weight-bold green--text">Dec 2021 </div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Senior Software Developer</strong>
                <div class="caption mb-2">Allable Co.,Ltd · Full-time</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">Jan 2010 -</div>
                <div class="caption font-weight-bold green--text">Jun 2011</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>IT Assistant-Director</strong>
                <div class="caption mb-2">P.B. For Books(Pathumthani) Co.,Ltd · Full-time</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-flex>
    <!-- <v-layout row justify-center align-center wrap class="mt-4 pt-2">
      <v-flex xs12 sm12 md4 lg5 xl5 class="mx-2 pt-4">
        <h2>
          <span>Design</span>

          <span class="green--text">Skills</span>
        </h2>
        <br>
        <strong>Photoshop</strong>
        <v-progress-linear v-model="buffer1" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
        <strong>Adobe XD</strong>
        <v-progress-linear v-model="buffer2" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
        <strong>Zeplin</strong>
        <v-progress-linear v-model="buffer3" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
      </v-flex>
      <v-flex xs12 sm12 md4 lg5 xl5 class="mx-2 pt-4">
        <h2>
          <span>Coding</span>
          <span class="green--text">Skills</span>
        </h2>
        <br>
        <strong>VUE/NUXT</strong>
        <v-progress-linear v-model="buffer4" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
        <strong>HTML/CSS</strong>
        <v-progress-linear v-model="buffer5" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
        <strong>JavaScript</strong>
        <v-progress-linear v-model="buffer6" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
      </v-flex>
      <div class="mt-4 pt-2">
        <v-btn
          href="https://docs.google.com/document/d/1WSR42FEgUahJuR_RArW1wz7TfUBlgj13zekRidmQgs4/edit?usp=sharing"
          target="_blank"
          color="green"
          dark
          large
        >
          Download Resume
          <v-icon right dark>fas fa-file-download</v-icon>
        </v-btn>
      </div>
    </v-layout> -->
  </v-layout>
</template>

<script>
export default {
  metaInfo: {
    title: "Resume",
    titleTemplate: "%s ← Borisutjai Space",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Vue NUXT HTML CSS JavaScript Design Adobe XD Photoshop Coding Skills Resume Work Web Developer Front-End"
      },
      { charset: "utf-8" },
      { property: "og:title", content: "Borisutjai Space" },
      { property: "og:site_name", content: "Borisutjai Space" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://borisutjai.com" },
      {
        property: "og:image",
        content: "./assets/images/Dcz2PGx.jpg"
      },
      {
        property: "og:description",
        content:
          "Vue NUXT HTML CSS JavaScript Design Adobe XD Photoshop Coding Skills Resume Work Web Developer Front-End"
      }
    ]
  },
  data() {
    return {
      value: 0,
      buffer1: 0,
      buffer2: 0,
      buffer3: 0,
      buffer4: 0,
      buffer5: 0,
      buffer6: 0,
      bufferValue: 100,
      interval: 0
    };
  },
  mounted() {
    this.startBuffer();
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  methods: {
    startBuffer() {
      this.interval = setInterval(() => {
        this.buffer1 = 90;
        this.buffer2 = 85;
        this.buffer3 = 80;
        this.buffer4 = 80;
        this.buffer5 = 90;
        this.buffer6 = 70;
      }, 800);
    }
  }
};
</script>
<style >
</style>

